import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { useNodesTreeContext } from '../NodesTreeContext/NodesTreeContext';
import {
  SectionsContextProviderDefaultProps,
  SectionsContextProviderPropTypes,
} from './SectionsContextProvider.proptypes';

const SectionsContext = createContext(null);

const SectionsContextProvider = ({ children, pageName }) => {
  const { ...depths } = useParams();

  const allDepths = [].concat(...Object.values(depths));

  const { nodesTree, isSuccess, isLoading } = useNodesTreeContext();

  const extractParentsWithChildrenAtDepth = (data, depthsParams) => {
    if (
      !data ||
      data.length === 0 ||
      !depthsParams ||
      depthsParams.length === 0
    ) {
      return [];
    }

    const parents = [];

    const extractAtDepth = (depthsData, initialData) => {
      const [depth, ...remainingDepths] = depthsData;
      const currentDepth = initialData.find((item) => item.slug === depth);

      if (!currentDepth) return parents;

      parents.push(currentDepth);

      if (remainingDepths.length > 0) {
        const currentChildren = currentDepth.children || [];
        return extractAtDepth(remainingDepths, currentChildren);
      }

      return { parents, children: currentDepth.children || [] };
    };

    return extractAtDepth(depthsParams, data);
  };

  return (
    <SectionsContext.Provider
      value={{
        allDepths,
        data: extractParentsWithChildrenAtDepth(nodesTree, allDepths),
        pageName,
        isSuccess,
        isLoading,
      }}
    >
      {children}
    </SectionsContext.Provider>
  );
};

SectionsContextProvider.defaultProps = {
  ...SectionsContextProviderDefaultProps,
};

SectionsContextProvider.propTypes = {
  ...SectionsContextProviderPropTypes,
};

export const useSectionsContext = () => useContext(SectionsContext);

export default SectionsContextProvider;
